"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styled_components_1 = require("styled-components");
exports.RotateHandle = React.forwardRef(function (props, ref) { return (React.createElement(Root, __assign({ viewBox: "0 0 24 24" }, props, { ref: ref }),
    React.createElement("path", { fill: "#000000", stroke: "#ffffff", strokeOpacity: "0.5", strokeWidth: "1", d: "M13,4.07V1L8.45,5.55L13,10V6.09C15.84,6.57 18,9.03 18,12C18,14.97 15.84,17.43 13,17.91V19.93C16.95,19.44 20,16.08 20,12C20,7.92 16.95,4.56 13,4.07M7.1,18.32C8.26,19.22 9.61,19.76 11,19.93V17.9C10.13,17.75 9.29,17.41 8.54,16.87L7.1,18.32M6.09,13H4.07C4.24,14.39 4.79,15.73 5.69,16.89L7.1,15.47C6.58,14.72 6.23,13.88 6.09,13M7.11,8.53L5.7,7.11C4.8,8.27 4.24,9.61 4.07,11H6.09C6.23,10.13 6.58,9.28 7.11,8.53Z" }))); });
exports.default = exports.RotateHandle;
var Root = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    left: ", ";\n    top: ", ";\n    width: 15px;\n    height: 15px;\n    opacity: 0;\n    cursor: pointer;\n    transform-origin: center;\n\n    &:hover {\n        opacity: 1;\n    }\n\n    &:after {\n        content: '';\n        position: absolute;\n        top: -5px;\n        bottom: -5px;\n        left: -5px;\n        right: -5px;\n    }\n"], ["\n    position: absolute;\n    left: ", ";\n    top: ", ";\n    width: 15px;\n    height: 15px;\n    opacity: 0;\n    cursor: pointer;\n    transform-origin: center;\n\n    &:hover {\n        opacity: 1;\n    }\n\n    &:after {\n        content: '';\n        position: absolute;\n        top: -5px;\n        bottom: -5px;\n        left: -5px;\n        right: -5px;\n    }\n"])), function (props) { return calculateLeft(props); }, function (props) { return calculateTop(props); });
var OFFSET = 2;
var calculateLeft = function (props) {
    return props.left
        ? "calc(0% - " + (OFFSET + 15) + "px)"
        : props.right
            ? "calc(100% + " + OFFSET + "px)"
            : 'calc(50% - 7.5px)';
};
var calculateTop = function (props) {
    return props.top
        ? "calc(0% - " + (OFFSET + 15) + "px)"
        : props.bottom
            ? "calc(100% + " + OFFSET + "px)"
            : 'calc(50% - 7.5px)';
};
var templateObject_1;
//# sourceMappingURL=RotateHandle.js.map